<h3 uilab-mat-dialog-title>ADS Downloads Restricted</h3>
<div uilab-mat-dialog-content>
    <p>Your browser does not support downloads.</p>
    <p>Please switch to another browser (like chrome).</p>
</div>
<div uilab-mat-dialog-actions>
    <button uilab-mat-button color="primary" (click)="close()" cdkFocusInitial
        >Ok</button
    >
</div>
